import React from 'react';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import MusicAlbumEditForm2AddPopup from './MusicAlbumEditForm2AddPopup';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity, MusicFeaturingArtistEntity } from '../../types/MusicEntityTypes';
import  MusicAlbumEditForm2View from './MusicAlbumEditForm2View';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

export default function MusicAlbumEditForm2({
  musicAlbum
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity & {
        music_featuring_artists: MusicFeaturingArtistEntity[],
      },
    })[],
  }
}) {
  const [popup, setPopup] = React.useState<'select'|null>(null);
  const [errors, setErrors] = React.useState<{ [key: string]: FieldValidationErrorsType } >({});
  const {
    getMusicAlbumTracks,
    sortMusicAlbumTracks,
    movePrevMusicAlbumTrack,
    moveNextMusicAlbumTrack,
    deleteMusicAlbumTrack,
    validateMusicAlbumTracks,
  } = React.useContext(MusicDistributionClientContext);

  const [musicAlbumTracks, setMusicAlbumTracks] = React.useState<(MusicAlbumTrackEntity & {
    music: MusicEntity & {
      music_featuring_artists: MusicFeaturingArtistEntity[],
    },
  })[]>([]);

  const reloadMusics = () => {
    getMusicAlbumTracks(musicAlbum.id).then((data) => {
      setMusicAlbumTracks(data.musicAlbumTracks);
    });
  };

  React.useEffect(() => {
    reloadMusics();
  }, []);

  const handleSort = (ids: string[]) => {
    const trackNos = ids.map((u) => parseInt(u, 10));
    sortMusicAlbumTracks(musicAlbum.id, trackNos).then(() => {
      reloadMusics();
    });
  };

  const handleMovePrev = (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => {
    movePrevMusicAlbumTrack(musicAlbum.id, musicAlbumTrack.id, trackNo).then(() => {
      reloadMusics();
    });
  };

  const handleMoveNext = (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => {
    moveNextMusicAlbumTrack(musicAlbum.id, musicAlbumTrack.id, trackNo).then(() => {
      reloadMusics();
    });
  };

  const handleDelete = (musicAlbumTrack: MusicAlbumTrackEntity) => {
    deleteMusicAlbumTrack(musicAlbum.id, musicAlbumTrack.id).then(() => {
      reloadMusics();
    });
  };

  const handleSubmit = (callback: ((musicAlbumId: number) => void)|null) => {
    validateMusicAlbumTracks(musicAlbum.id).then((data) => {
      if (data.result) {
        if (callback) {
          callback(musicAlbum.id);
        } else {
          document.location.href = `/music_albums/edit_tracks/${musicAlbum.id}`;
        }
      } else {
        setErrors(data.validationErrors as { [key:string]: FieldValidationErrorsType });
      }
    });
  };

  return (
    <>
      <MusicAlbumEditForm2View
        musicAlbum={musicAlbum}
        musicAlbumTracks={musicAlbumTracks}
        onMovePrev={(musicAlbumTrack, trackNo) => handleMovePrev(musicAlbumTrack, trackNo)}
        onMoveNext={(musicAlbumTrack, trackNo) => handleMoveNext(musicAlbumTrack, trackNo)}
        onDelete={(musicAlbumTrack) => handleDelete(musicAlbumTrack)}
        onStep={(callback: ((musicAlbumId: number) => void)) => handleSubmit(callback)}
        onSubmit={() => handleSubmit(null)}
        onSelect={() => { setPopup('select'); }}
        onCancel={() => document.location.href = `/music_albums/edit/${musicAlbum.id}` }
        getErrors={() => errors.music_album_tracks || []}
        onSort={(ids) => handleSort(ids)}
      />
      {popup === 'select' && (
        <MusicAlbumEditForm2AddPopup
          musicAlbum={musicAlbum}
          onDone={() => { setPopup(null); reloadMusics(); }}
          onCancel={() => { setPopup(null); }}
        />
      )}
    </>
  );
}
